import { useEffect, useRef } from 'react';

export const BinaryBackground = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const createBinaryStream = () => {
      const element = document.createElement('div');
      element.className = 'binary-text';
      element.style.left = `${Math.random() * 100}%`;
      element.textContent = Array(20)
        .fill(0)
        .map(() => Math.round(Math.random()))
        .join(' ');

      container.appendChild(element);

      setTimeout(() => {
        element.remove();
      }, 10000);
    };

    const interval = setInterval(createBinaryStream, 300);

    return () => {
      clearInterval(interval);
      container.innerHTML = '';
    };
  }, []);

  return <div ref={containerRef} className="binary-bg" />;
};